import * as React from 'react';
import { useIntl } from 'react-intl';
import { CmdModal, CmdModalFooterButton } from '@commander-services/gui-components';
import TooltipComponent from '../TooltipComponent';
import { IChipInputItem } from '../Forms/Fields/ChipInput';
import { IGroupDataVehicleGroupForm } from './types';
import { postRequest } from '../../Services/HttpService';
import { AxiosResponse } from 'axios';

interface IConditions {
  id: number;
  item: string;
}

interface IVehicleGroupFormProps {
  closeCallback: () => void;
  groupData: IGroupDataVehicleGroupForm[];
  groupId: string;
  rideOwnership: string;
  conditions: IChipInputItem[];
}

interface IOptionData {
  item: string;
  value: number;
  passed: boolean;
  popup: string | null;
}

function VehicleListInGroupForm(props: IVehicleGroupFormProps): JSX.Element | null {
  const { formatMessage: f } = useIntl();
  const [optionsData, setOptionsData] = React.useState<IOptionData[]>([]);
  const [origData, setOrigData] = React.useState<IOptionData[]>([]);
  const [loader, setLoader] = React.useState<boolean>(false);
  const [isGroupDeleted, setIsGroupDeleted] = React.useState<boolean>(true);

  const getTempData = async () => {
    const tempGroup: IGroupDataVehicleGroupForm | undefined = props.groupData.find(
      (group: IGroupDataVehicleGroupForm) => String(group.id) === String(props.groupId)
    );
    const conditionsValue = props.conditions.map((item: IChipInputItem) => item.id);
    const values = {
      rideOwnership: props.rideOwnership,
      conditions: conditionsValue,
      vehicleId: tempGroup?.vehicleId || [],
    };
    setLoader(true);
    const response: IOptionData[] | false = await postRequest(`/v1/alarm/form/vehicle-group-vehicles`, values);
    setLoader(false);
    if (response) {
      setOptionsData(response);
      setOrigData(response);
    }
  };

  const getData = async () => {
    const conditionsValue = props.conditions.map((item: IChipInputItem) => item.id);
    const values = {
      rideOwnership: props.rideOwnership,
      conditions: conditionsValue,
    };
    setLoader(true);
    const response: AxiosResponse | false = await postRequest(
      `/v1/alarm/form/vehicle-group-vehicles/${props.groupId}`,
      values,
      { returnAxiosResponse: true, returnAxioErrorResponseData: true }
    );
    setLoader(false);
    if (response && response.data && response.status === 200) {
      setOptionsData(response.data);
      setOrigData(response.data);
      setIsGroupDeleted(false);
    }
    if (response && response.status === 404) {
      props.closeCallback();
    }
  };

  React.useEffect(() => {
    const id = props.groupId;
    const idArr = id.split('_');
    if (idArr && idArr[0] && idArr[0] === 'temp') {
      getTempData();
    } else {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buttons: CmdModalFooterButton[] = [
    {
      id: 'close-modal',
      type: 'button',
      className: 'e-button',
      title: f({ id: 'alarms.modal.rule.button.close' }),
      closeCallback: props.closeCallback,
    },
  ];

  const filterItems = (value: boolean) => {
    let newOptions = JSON.parse(JSON.stringify(origData));
    if (value === true) {
      newOptions = newOptions.filter((i) => i.passed === false);
      setOptionsData(newOptions);
    } else {
      setOptionsData(origData);
    }
  };

  if (isGroupDeleted) {
    return null;
  }

  return (
    <CmdModal
      id="vehiclelist-form-modal"
      title={f({ id: 'alarms.modal.vehicles.title' })}
      footerButtons={buttons}
      modalFooterCheckbox={f({ id: 'alarms.modal.vehciles.show_error_vehicles' })}
      modalFooterCheckboxCallback={filterItems}
      loader={loader}
      data-cy="vehiclelist-form-modal"
      // usePortal={true}
    >
      <div
        style={{ margin: '0 0 7px', maxHeight: '400px', overflow: 'auto' }}
        className="filtered-list"
      >
        {Object.values(optionsData).map((item, index: number) => (
          <div
            style={{
              padding: '10px 12px',
              color: '#555',
            }}
            className="filtered-item"
            key={`vehicle-item-${index}`}
          >
            <div className="e-checkbox">
              <label>
                <span data-cy={`span-vehicle-group-form-${item.value}`}>
                  {item.item} &nbsp;
                  {item.passed === false &&
                    (item.popup ? (
                      <TooltipComponent
                        id={props.groupId}
                        display="inline"
                        firstItems={true}
                        overlay={<div style={{ color: '#fff' }}>{item.popup}</div>}
                        key="err"
                        data-cy={`tooltip-vehicle-group-form-${item.value}`}
                      >
                        <i
                          id={`icon-${item.value}`}
                          className="cmd-icon cmd-icon-exclamation text-primary"
                          data-cy={`tooltip-icon-vehicle-group-form-${item.value}`}
                        />
                      </TooltipComponent>
                    ) : (
                      <i
                        id={`icon-${item.value}`}
                        className="cmd-icon cmd-icon-exclamation text-primary"
                        data-cy={`icon-vehicle-group-form-${item.value}`}
                      />
                    ))}
                </span>
              </label>
            </div>
          </div>
        ))}
        <div style={{ height: '24px' }} />
      </div>
    </CmdModal>
  );
}

export default VehicleListInGroupForm;
